export default __webpack_public_path__ + "static/media/menu_icon.f8905879.svg";